<template>
  <div class="abtest-target-component">
    <div class="segments-platforms">
      <VdIcon store="fas" name="users" />
      <div>
        <div class="segments-list" :class="{ 'align-right': alignRight }">
          <div v-for="(segment, i) in displayedSegments" :key="segment" class="segment">
            <div>{{ segment }}</div>
            <div v-if="i + 1 < displayedSegments.length" class="segment-condition">OR</div>
          </div>
          <div v-if="hasMoreSegments" class="segment-condition">+{{ segmentNames.length - 3 }}</div>
        </div>
        <PlatformGameVersionsLabel :value="platform" :align-right="alignRight" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { PropType, computed, defineComponent } from "vue";

import VdIcon from "@/components/VdIcon/VdIcon.vue";
import { GamePlatform } from "@/graphql";
import PlatformGameVersionsLabel from "@/pages/games/GameDisplay/children/configurations/components/PlatformGameVersionsLabel.vue";

export default defineComponent({
  name: "AbtestAudience",

  components: {
    PlatformGameVersionsLabel,
    VdIcon,
  },

  props: {
    segmentNames: {
      type: Array as PropType<string[]>,
      required: true,
    },

    platform: {
      type: Object as PropType<GamePlatform | null>,
      required: true,
    },

    alignRight: {
      type: Boolean,
      default: false,
    },

    isDynamic: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const displayedSegments = computed(() => props.segmentNames.slice(0, 3));
    const hasMoreSegments = computed(() => props.segmentNames.length > 3);

    return {
      displayedSegments,
      hasMoreSegments,
    };
  },
});
</script>

<style lang="scss" scoped>
.abtest-target-component {
  background-color: var(--vd-color-surface-100);
  border-radius: 1rem;
  padding: 0.5rem 0.75rem;

  .segments-platforms {
    display: flex;
    flex-direction: row;
    align-items: center;

    > div {
      margin-left: size("M");
    }

    svg {
      fill: var(--vd-color-text-default);
    }
  }

  .segment {
    display: flex;
    align-items: center;
    margin-right: 4px;
    color: var(--vd-color-text-default);
    font-weight: 600;
    font-size: font("S");

    & > div {
      @include ellipsis;
      max-width: 100px;
    }
  }

  .dynamic-segments-label {
    font-weight: 600;
    font-size: 10px;
    margin: 0;
    margin-bottom: 0;
  }

  .segment-condition {
    margin: 0 4px;
    margin-right: 2px;
    color: var(--vd-color-blue-gray-500);
    border: 1px solid var(--vd-color-blue-gray-100);
    background: white;
    padding: 2px 4px;
    border-radius: 0.25rem;
  }

  .segments-list {
    @include ellipsis;
    display: flex;
    justify-content: flex-start;
    max-width: 380px;
    font-weight: 600;
    font-size: font("S");

    &.align-right {
      justify-content: flex-end;
    }

    .segment:not(:last-of-type):after {
      margin-right: size("XS");
    }
  }
}
</style>
